import { render, staticRenderFns } from "./dunningAdmin.vue?vue&type=template&id=4fb43bf0"
import script from "./dunningAdmin.vue?vue&type=script&lang=js"
export * from "./dunningAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports